export default __webpack_public_path__ + "static/media/icon-chrome.ea57f9c7.svg";